<template>
  <Menu buttonText="Register Here" />
  <main id="home" class="presenters">
    <div class="companies">
      <presenters />
      <cta />
      <sponsors />
    </div>
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
import Menu from '@/components/menu';
import presenters from '@/components/presenters.vue';
import sponsors from '@/components/sponsors.vue';
import cta from '@/components/cta.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    Menu,
    presenters,
    cta,
    sponsors
  },
};
</script>